import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AccountFeeComp from "./Component/AccountFeeComp"


const AccountFee =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AccountFeeComp />
        </div>
        <Footer />
        </>
    )
}

export default AccountFee